function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: 0;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_discord",
  transform: "translate(-1339 -4052)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62_626",
  "data-name": "\\u77E9\\u5F62 626",
  className: "cls-1",
  width: 18,
  height: 18,
  transform: "translate(1339 4052)"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7EC4_766",
  "data-name": "\\u7EC4 766",
  transform: "translate(1342 4054.25)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "\\u692D\\u5706_84",
  "data-name": "\\u692D\\u5706 84",
  cx: 0.794,
  cy: 0.836,
  rx: 0.794,
  ry: 0.836,
  transform: "translate(6.908 5.896)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "\\u692D\\u5706_85",
  "data-name": "\\u692D\\u5706 85",
  cx: 0.794,
  cy: 0.836,
  rx: 0.794,
  ry: 0.836,
  transform: "translate(4.254 5.896)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u8DEF\\u5F84_1659",
  "data-name": "\\u8DEF\\u5F84 1659",
  d: "M-82.318,11.6h-9.72a1.487,1.487,0,0,0-1.5,1.456v9.563a1.462,1.462,0,0,0,1.5,1.456h8.264l-.394-1.3.944.826.866.787,1.574,1.338V13.056A1.549,1.549,0,0,0-82.318,11.6Zm-2.794,9.248s-.275-.315-.472-.59a2.345,2.345,0,0,0,1.3-.826,8.681,8.681,0,0,1-.826.433,5.438,5.438,0,0,1-1.062.315,6.058,6.058,0,0,1-1.889,0,4.936,4.936,0,0,1-1.062-.315c-.157-.079-.354-.157-.551-.236-.039,0-.039-.039-.079-.039h-.039a2.045,2.045,0,0,0-.2-.118,2.334,2.334,0,0,0,1.259.826c-.236.275-.472.59-.472.59a2.574,2.574,0,0,1-2.2-1.062,9.206,9.206,0,0,1,1.063-4.132,3.521,3.521,0,0,1,2.046-.748l.079.079a4.2,4.2,0,0,0-1.889.905s.157-.079.433-.2a5.246,5.246,0,0,1,1.653-.433h.118a6,6,0,0,1,1.456,0,6.385,6.385,0,0,1,2.2.669,4.754,4.754,0,0,0-1.81-.905l.118-.118a3.521,3.521,0,0,1,2.046.748,9.206,9.206,0,0,1,1.063,4.132A3.1,3.1,0,0,1-85.112,20.848Z",
  transform: "translate(93.533 -11.6)"
})));

function SvgIconDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/icon_discord.e9e960a2.svg";
export { ForwardRef as ReactComponent };